import React, { useState, useEffect } from "react";

import { Link, NavLink, Outlet } from "react-router-dom";
import menus from "../../pages/menu";

import logo from "../../assets/images/logo/logo.png";
import { motion } from "framer-motion";

import "./styles.scss";

const Header = (children, { logoTransitioning = null }) => {
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 300);
    });
    return () => {
      setScroll({});
    };
  }, []);

  const [menuActive, setMenuActive] = useState(null);

  const handleMenuActive = () => {
    setMenuActive(!menuActive);
  };

  const [activeIndex, setActiveIndex] = useState(null);
  const handleDropdown = (index) => {
    setActiveIndex(index);
  };

  const [isMobileView, setIsMobileView] = useState(false);

  // Check for mobile view based on window width
  useEffect(() => {
    const checkMobileView = () => {
      setIsMobileView(window.innerWidth <= 768); // Adjust the width breakpoint as needed
    };

    // Add event listener for resizing
    window.addEventListener("resize", checkMobileView);
    checkMobileView(); // Initial check

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  return (
    <>
      <motion.header
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        id="header_main"
        className={`header ${scroll ? "is-fixed" : ""}`}
      >
        <div className="container big">
          <div className="row">
            <div className="col-12">
              <div className="header__body">
                <div className="header__logo">
                  <Link to="/">
                    <img
                      id="site-logo"
                      src={logo}
                      alt="PlayerzPortal"
                      style={{ height: "100px" }}
                    />
                    {/* <p className="text-xl">PlayerzPortal</p> */}
                  </Link>
                </div>

                <div className="header__right">
                  <nav
                    id="main-nav"
                    className={`main-nav ${menuActive ? "active" : ""}`}
                  >
                    <ul id="menu-primary-menu" className="menu">
                      {menus
                        .filter(
                          (data) =>
                            isMobileView || (data.id !== 2 && data.id !== 3)
                        ) // Show all in mobile view, filter for desktop

                        .map((data, idx) => (
                          <li
                            key={idx}
                            onClick={() => handleDropdown(idx)}
                            className={`menu-item ${
                              data.namesub ? "menu-item-has-children" : ""
                            } ${activeIndex === idx ? "active" : ""}`}
                          >
                            <Link to={data.links}>{data.name}</Link>
                            {data.namesub && (
                              <ul className="sub-menu">
                                {data.namesub.map((submenu) => (
                                  <li key={submenu.id} className="menu-item">
                                    <NavLink to={submenu.links}>
                                      {submenu.sub}
                                    </NavLink>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                    </ul>
                  </nav>
                  <div
                    className={`mobile-button ${menuActive ? "active" : ""}`}
                    onClick={handleMenuActive}
                  >
                    <span></span>
                  </div>
                </div>

                <div className="header__action">
                  <Link to="#" className="search-btn">
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="9.7659"
                        cy="9.76639"
                        r="8.98856"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.0176 16.4849L19.5416 19.9997"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                  <Link to="/login" className="ms-2 ">
                    <small className="ms-2">Login</small>
                  </Link>
                  <Link to="/signup" className="action-btn">
                    <span>Join Now</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.header>
      <Outlet />
    </>
  );
};

export default Header;
